import React from 'react';
import Header from '../../../Reusable/Header';
import Footer from '../../../Reusable/Footer';
import Hero from './Page components/Home/Hero';
import AchievementCards from './Page components/Home/Card';
import CampaignFeatures from './Page components/Home/CampainFeatures';
import ThreeStepGuide from './Page components/Home/Steps';
import Ourpromise from './Page components/Home/Ourpromise';
import FeaturedCampaigns from './Page components/Home/FeaturedCompaigns';
import TestingNotice from '../../../Reusable/TestingNotice';
import useSEO from '../../../../hooks/useSEO';

const HOME_STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://yamba.africa/#organization',
      name: 'Yamba Africa',
      url: 'https://yamba.africa',
      logo: {
        '@type': 'ImageObject',
        url: 'https://yamba.africa/favicon.png',
      },
      description:
        'Yamba Africa is a crowdfunding platform that connects donors with meaningful fundraising campaigns across Africa.',
    },
    {
      '@type': 'WebSite',
      '@id': 'https://yamba.africa/#website',
      url: 'https://yamba.africa',
      name: 'Yamba Africa',
      publisher: { '@id': 'https://yamba.africa/#organization' },
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://yamba.africa/campaigns?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
  ],
};

const Home = () => {
  useSEO({
    title: 'Crowdfunding Platform for African Causes',
    description:
      'Yamba Africa helps you start a fundraiser or donate to meaningful campaigns across Africa. Join thousands of changemakers supporting education, health, and community causes.',
    url: 'https://yamba.africa/',
    keywords:
      'crowdfunding Africa, fundraising Africa, donate Africa, African campaigns, charity Uganda, start fundraiser Africa',
    structuredData: HOME_STRUCTURED_DATA,
  });

  return (
    <div>
      <Header />
      <Hero />

      <AchievementCards />
      <FeaturedCampaigns />

      <CampaignFeatures />
      <ThreeStepGuide />
      <Ourpromise />





      <Footer />

      <TestingNotice />

    </div>
  );
};

export default Home;
